export default __webpack_public_path__ + "static/media/APPOINTMENT_TIME.8ffdcaad.png";